import React, { Fragment, useState, useEffect } from "react";
import { useNotification } from "hooks/Notification";
import SimpleNotification from "./SimpleNotification";

export default function NotificationPortal(props) {
    const notification = useNotification();
    const [stack, setStack] = useState([]);

    useEffect(() => {
        const interval = setInterval(() => {
            if (notification.hasNext()) {
                setStack((s) => [...s, notification.getNext()]);
            }
        });
        return () => clearInterval(interval);
    }, [notification]);

    return (
        <Fragment>
            {/* Global notification live region, render this permanently at the end of the document */}
            <div
                aria-live="assertive"
                className="pointer-events-none fixed inset-x-0 top-2 flex items-end px-4 py-6 sm:items-start sm:p-6 z-50"
            >
                <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
                    {stack.map((item, index) => (
                        <SimpleNotification key={index} {...item} />
                    ))}
                </div>
            </div>
        </Fragment>
    );
}
